import { CroppingPatternReportModel, Product } from "@agroyaar/sdk";
import { Column } from "@/shared/components/report-template/domain/report-template.interface";

export const suggestedAreaColumns: Column<CroppingPatternReportModel>[] = [
  {
    field: "crop",
    headerName: "نام محصول",
    render: (value) => (value as Product).persianName,
  },
  {
    field: "netIrrigationRequirement",
    headerName: "نیاز خالص آبیاری (مترمکعب در هکتار)",
    format: "number",
  },
  {
    field: "compositeIndex",
    headerName: "شاخص ترکیبی الگو کشت",
    format: "decimal",
  },
  {
    field: "suggestedArea",
    headerName: "مساحت پیشنهادی (هکتار)",
    format: "number",
  },
];
